import Info from 'components/shared/Info'
import { FormattedMessage } from 'react-intl'
import Box, { BoxProps } from 'components/shared/Box'
import { useAppSelector } from 'store/hooks'
import { useMemo } from 'react'
import { PROMO_ID_SV79 } from 'components/shared/Promotions/constants'

interface AutoPromotionsInfoProps extends BoxProps, BoxProps {}

const AutoPromotionsInfo = (props: AutoPromotionsInfoProps) => {
    const { cart } = useAppSelector((state) => state.cart)
    const { promotions: cartPromotions } = cart || {}

    const isSv79PromoApplied = useMemo(
        () =>
            !!cartPromotions?.find(
                ({ promotionId }) => promotionId === PROMO_ID_SV79
            ),
        [cartPromotions]
    )

    const hasAppliedPromotions = isSv79PromoApplied

    return hasAppliedPromotions ? (
        <Box gap={16} {...props}>
            {isSv79PromoApplied && (
                <Info
                    color="success"
                    hasSmallFont={true}
                    hasIcon={false}
                    textAlign={['left', 'center']}
                    isFullWidthContent
                >
                    <FormattedMessage
                        id="promo.accommodation.auto_promotions_79_cart_info"
                        defaultMessage="Zastosowano promocję Dwie Noce w Tropikach"
                    />
                </Info>
            )}
        </Box>
    ) : null
}

export default AutoPromotionsInfo
